import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/** Заголовки карточек показателей: их читают и живая карточка, и скелетон — заголовок в нём настоящий. */
export const KPI_LABELS = {
  championships: msg`Чемпионатов`,
  matches: msg`Матчей`,
  playedMatches: msg`Сыгранных матчей`,
  uniqueTeams: msg`Уникальных команд`,
  totalGoals: msg`Голов забито`,
  averageGoals: msg`Среднее голов за матч`,
  gameDays: msg`Игровых дней`,
} satisfies Record<string, MessageDescriptor>;

export type KpiKey = keyof typeof KPI_LABELS;

/** Порядок карточек в сетке; у «Сыгранных матчей» под значением есть полоса прогресса. */
export const KPI_ORDER: ReadonlyArray<{ key: KpiKey; hasProgress: boolean }> = [
  { key: 'championships', hasProgress: false },
  { key: 'matches', hasProgress: false },
  { key: 'playedMatches', hasProgress: true },
  { key: 'uniqueTeams', hasProgress: false },
  { key: 'totalGoals', hasProgress: false },
  { key: 'averageGoals', hasProgress: false },
  { key: 'gameDays', hasProgress: false },
];
